/* ============================================
   THEME ONE - JavaScript
   Version: 1.0.0
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {
  // All interactive JS is inline in sections for Shopify compatibility
  console.log('Theme One loaded');
});
